import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { Select as ElSelect, Option as ElOption } from 'element-ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'ISelect',
  props: {
    value: { default: '' },
    items: { default: () => [] },
    icon: { default: '' },
    rules: { default: '' },
    errorLabel: { default: '' },
    width: { default: '' }
  },
  emits: ["input"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', newVal: string | number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string | number, items: { value: string | number; label: string }[], icon: string, rules: string, errorLabel: string, width: string };



const innerValue = computed({
  get() {
    return props.value;
  },
  set(newVal) {
    emit('input', newVal);
  },
});

return { __sfc: true,props, emit, innerValue, ElSelect, ElOption }
}

})